import $ from 'jquery';

export default {
	init() {
		var menuBreakpoint = 991;
		var $wraps = $('.navigation-wrap');
		if (!$wraps.length) {
			return;
		}

		function closeAllDropdowns($root) {
			$root.find('.w-dropdown').removeClass('w--open');
			$root.find('.w-dropdown-toggle').removeClass('w--open').attr('aria-expanded', 'false');
			$root.find('.w-dropdown-list').removeClass('w--open').hide();
		}

		function openDropdown($dropdown) {
			var $toggle = $dropdown.find('> .w-dropdown-toggle');
			var $list = $dropdown.find('> .w-dropdown-list');
			$dropdown.addClass('w--open');
			$toggle.addClass('w--open').attr('aria-expanded', 'true');
			$list.addClass('w--open').fadeIn();
		}

		function toggleDropdown($dropdown) {
			var $root = $dropdown.closest('.navigation-wrap');
			var isOpen = $dropdown.hasClass('w--open');
			closeAllDropdowns($root);
			if (!isOpen) {
				openDropdown($dropdown);
			}
		}

		function isDesktop() {
			return $(window).width() > menuBreakpoint;
		}

		// Desktop hover behavior (scoped)
		$wraps.on('mouseenter', '.w-dropdown', function () {
			if (!isDesktop()) {
				return;
			}
			var $root = $(this).closest('.navigation-wrap');
			closeAllDropdowns($root);
			openDropdown($(this));
		});

		$wraps.on('mouseleave', '.w-dropdown', function () {
			if (!isDesktop()) {
				return;
			}
			var $root = $(this).closest('.navigation-wrap');
			closeAllDropdowns($root);
		});

		// Mobile click behavior for dropdown toggles (scoped)
		$wraps.on('click', '.w-dropdown-toggle', function (event) {
			if (isDesktop()) {
				return;
			}
			event.preventDefault();
			var $dropdown = $(this).closest('.w-dropdown');
			toggleDropdown($dropdown);
		});

		// Close nav dropdowns when clicking outside the nav wrap(s)
		$(document).on('click', function (event) {
			var $target = $(event.target);
			$wraps.each(function () {
				var $wrap = $(this);
				if (!$target.closest($wrap).length) {
					closeAllDropdowns($wrap);
				}
			});
		});

		// Close nav dropdowns on escape key
		$(document).on('keydown', function (event) {
			if (event.key === 'Escape' || event.keyCode === 27) {
				$wraps.each(function () {
					closeAllDropdowns($(this));
				});
			}
		});

		// Mobile menu toggle (scoped)
		$wraps.on('click', '.w-nav-button', function () {
			var $button = $(this);
			var $nav = $button.closest('.w-nav');
			var $menu = $nav.find('> .w-nav-menu');
			var $overlay = $nav.find('> .w-nav-overlay');
			var $overlayNav = $overlay.find('> .w-nav-menu');

			var isOpen = $button.hasClass('w--open');
			if (isOpen) {
				$button.removeClass('w--open').attr('aria-expanded', 'false');
				$menu.removeAttr('data-nav-menu-open').hide();
				$overlay.hide();
				$overlayNav.hide();
			} else {
				$button.addClass('w--open').attr('aria-expanded', 'true');
				$menu.attr('data-nav-menu-open', 'true').show();
				$overlay.show();
				$overlayNav.show();
			}
		});

		function resizeHandler() {
			$wraps.each(function () {
				var $wrap = $(this);
				if (isDesktop()) {
					closeAllDropdowns($wrap);
					$wrap
						.find('.w-nav-button')
						.removeClass('w--open')
						.attr('aria-expanded', 'false');
					$wrap.find('.w-nav-menu').removeAttr('data-nav-menu-open').show();
					$wrap.find('.w-nav-overlay').hide();
				} else {
					$wrap.find('.w-nav-menu').removeAttr('data-nav-menu-open').hide();
					$wrap
						.find('.w-nav-button')
						.removeClass('w--open')
						.attr('aria-expanded', 'false');
					$wrap.find('.w-nav-overlay').hide();
				}
			});
		}

		$(window).on('resize', function () {
			resizeHandler();
		});

		$(window).on('load', function () {
			resizeHandler();
		});
	},
};
